import React from 'react';
import createReactClass from 'create-react-class';

import { FormRequestActions } from '../actions/formRequestActions';

export const FormBTrackRowView = createReactClass({
    render: function () {
        var track = this.props.track;
        var checkedTracks = this.props.checkedTracks;
        var l = checkedTracks.length;
        var isReadOnly = this.props.isReadOnly;
        var checked = false;
        for (var i = 0; i < l; i++) {
            if (checkedTracks[i].name.replace(/ /g, '') === track.name.replace(/ /g, '')) {
                checked = true;
                break;
            }
        }

        return (
            <div>
                <input type="checkbox"
                    disabled={isReadOnly}
                    checked={checked}
                    onChange={this.trackOnChange}
                    name={track.name}
                    id={track.name.replace(/ /g, '')} />
                {track.name}
            </div>
        );
    },

    trackOnChange: function (e) {
        FormRequestActions.trackSelectChanged(e.target.name, e.target.checked);
    },
});
